import { ImportCsvModal } from 'iron-forge-react-modules';



export type NetSuiteEmployeesPropertyName =
  | 'internalId'
  | 'name'



export const propertyName2Comment: Record<NetSuiteEmployeesPropertyName, string> = {
  internalId: 'internalId',
  name: 'name'
};



export const propertyName2Data: Record<NetSuiteEmployeesPropertyName, ImportCsvModal.IFormatTypeData> = {
  internalId: {
    example: "188",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "John Smith.",
    properFormat: "",
    fnValidate: () => true
  }
};



export type IColumnDef = ImportCsvModal.IColumnDescription<NetSuiteEmployeesPropertyName>;

export const columnDefs: IColumnDef[] = [
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Name',
    label: 'Name',
    isRequired: true,
    formatType: undefined
  }
];
